export default "__VITE_ASSET__CZLC6s8E__"